import { useInfiniteQuery } from 'react-query';

import {
  COMMENTS_PER_PAGE,
  CommentableType,
  CommentsResponse,
  getComments,
  getCommentsKey,
} from '@utils/backend-api/comments';

export default function useComments(
  commentableId: number,
  commentableType: CommentableType,
  commentId?: string
) {
  const { data, isLoading, fetchNextPage, hasNextPage } = useInfiniteQuery<CommentsResponse>(
    getCommentsKey(commentableId, commentableType),
    ({ pageParam = 1 }) =>
      getComments({
        commentable_id: commentableId,
        commentable_type: commentableType,
        comment_id: commentId,
        per_page: commentableType === CommentableType.ForumPost ? 99999 : COMMENTS_PER_PAGE,
        page: pageParam,
        replies_per_comment: 50,
      }),
    {
      getNextPageParam: (lastPage) => {
        return lastPage.next_page;
      },
    }
  );

  return {
    commentsData: data,
    totalComments: data?.pages[0].total_comments ?? 0,
    isLoadingComments: isLoading,
    fetchNextPage,
    hasMoreComments: hasNextPage,
  };
}
